export default "__VITE_ASSET__BVtEGJyD__"